import { actionCreator } from 'utils';
import * as PackageTypes from '../types/packageTypes';


// L O A D   P A C K A G E S
export function loadPackages() {
    return {
        type: PackageTypes.LOAD_PACKAGES,
    };
}

export function loadPackagesRes(data) {
    return {
        type: actionCreator(PackageTypes.LOAD_PACKAGES, 'res'),
        data,
    };
}

export function loadPackagesErr() {
    return {
        type: actionCreator(PackageTypes.LOAD_PACKAGES, 'err'),
    };
}
// L O A D   P A C K A G E S


// S E T   P A C K A G E   F I L T E R
export function setPackageFilter(key, value) {
    return {
        type: PackageTypes.SET_PACKAGE_FILTER,
        key,
        value,
    };
}

export function setPackagePagination(key, pagination) {
    return {
        type: PackageTypes.SET_PACKAGE_PAGINATION,
        key,
        pagination,
    };
}

export function setPackageSort(sort) {
    return {
        type: PackageTypes.SET_PACKAGE_SORT,
        sort,
    };
}

export function resetPackageFilters() {
    return {
        type: PackageTypes.RESET_PACKAGE_FILTERS,
    };
}
// S E T   P A C K A G E   F I L T E R


// L O A D   C O N F I G U R A T I O N S   F O R   P A C K A G E
export function loadConfigurationsForPackage(prop) {
    return {
        type: PackageTypes.LOAD_CONFIGURATIONS_FOR_PACKAGE,
        prop,
    };
}

export function loadConfigurationsForPackageRes(prop, data) {
    return {
        type: actionCreator(PackageTypes.LOAD_CONFIGURATIONS_FOR_PACKAGE, 'res'),
        prop,
        data,
    };
}

export function loadConfigurationsForPackageErr(prop) {
    return {
        type: actionCreator(PackageTypes.LOAD_CONFIGURATIONS_FOR_PACKAGE, 'err'),
        prop,
    };
}
// L O A D   C O N F I G U R A T I O N S   F O R   P A C K A G E


// S E T   C O N F I G U R A T I O N   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T   F O R   P A C K A G E
export function setConfigurationFiltersForPackage(prop, key, value) {
    return {
        type: PackageTypes.SET_CONFIGURATION_FILTER_FOR_PACKAGE,
        prop,
        key,
        value,
    };
}

export function setConfigurationFiltersForPackageRes(prop, data) {
    return {
        type: actionCreator(PackageTypes.SET_CONFIGURATION_FILTER_FOR_PACKAGE, 'res'),
        prop,
        data,
    };
}

export function setConfigurationPaginationForPackage(prop, key, pagination) {
    return {
        type: PackageTypes.SET_CONFIGURATION_PAGINATION_FOR_PACKAGE,
        prop,
        key,
        pagination,
    };
}

export function setConfigurationSortForPackage(prop, sort) {
    return {
        type: PackageTypes.SET_CONFIGURATION_SORT_FOR_PACKAGE,
        prop,
        sort,
    };
}

export function resetConfigurationFiltersForPackage(prop) {
    return {
        type: PackageTypes.RESET_CONFIGURATION_FILTERS_FOR_PACKAGE,
        prop,
    };
}
// S E T   C O N F I G U R A T I O N   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T   F O R   P A C K A G E


// S E T   C H E C K E D   C O N F I G U R A T I O N   F O R   P A C K A G E
export function setCheckedConfigurationsForPackage(prop, ids) {
    return {
        type: PackageTypes.SET_CHECKED_CONFIGURATIONS_FOR_PACKAGE,
        prop,
        ids,
    };
}
// S E T   C H E C K E D   C O N F I G U R A T I O N   F O R   P A C K A G E


// A D D   N E W   P A C K A G E
export function addNewPackage(data) {
    return {
        type: PackageTypes.ADD_NEW_PACKAGE,
        data,
    };
}

export function addNewPackageRes() {
    return {
        type: actionCreator(PackageTypes.ADD_NEW_PACKAGE, 'res'),
    };
}

export function addNewPackageErr(error) {
    return {
        type: actionCreator(PackageTypes.ADD_NEW_PACKAGE, 'err'),
        error,
    };
}
// A D D   N E W   P A C K A G E


// A D D   B U L K   P A C K A G E S
export function goToAddBulkPackagesStep(step) {
    return {
        type: PackageTypes.GO_TO_ADD_BULK_PACKAGES_STEP,
        step,
    };
}

export function addToBulkCartesians(packages) {
    return {
        type: PackageTypes.ADD_TO_BULK_CARTESIANS,
        packages,
    };
}

export function addBulkPackages(data) {
    return {
        type: PackageTypes.ADD_BULK_PACKAGES,
        data,
    };
}

export function addBulkPackagesRes() {
    return {
        type: actionCreator(PackageTypes.ADD_BULK_PACKAGES, 'res'),
    };
}

export function addBulkPackagesErr(error) {
    return {
        type: actionCreator(PackageTypes.ADD_BULK_PACKAGES, 'err'),
        error,
    };
}

export function updateProgressOfBulkPackages(data) {
    return {
        type: PackageTypes.UPDATE_PROGRESS_OF_BULK_PACKAGES,
        data,
    };
}

export function finishAddingBulkPackages() {
    return {
        type: PackageTypes.FINISH_ADDING_BULK_PACKAGES,
    };
}
// A D D   B U L K   P A C K A G E S


// L O A D   E D I T A B L E   P A C K A G E
export function loadEditablePackage(id) {
    return {
        type: PackageTypes.LOAD_EDITABLE_PACKAGE,
        id,
    };
}

export function loadEditablePackageRes(data) {
    return {
        type: actionCreator(PackageTypes.LOAD_EDITABLE_PACKAGE, 'res'),
        data,
    };
}

export function loadEditablePackageErr() {
    return {
        type: actionCreator(PackageTypes.LOAD_EDITABLE_PACKAGE, 'err'),
    };
}

export function setEmptyEditablePackage() {
    return {
        type: PackageTypes.SET_EMPTY_EDITABLE_PACKAGE,
    };
}
// L O A D   E D I T A B L E   P A C K A G E


// E D I T   P A C K A G E
export function editPackage(data) {
    return {
        type: PackageTypes.EDIT_PACKAGE,
        data,
    };
}

export function editPackageRes() {
    return {
        type: actionCreator(PackageTypes.EDIT_PACKAGE, 'res'),
    };
}

export function editPackageErr(error) {
    return {
        type: actionCreator(PackageTypes.EDIT_PACKAGE, 'err'),
        error,
    };
}

export function setConfigurationsToEditablePackage(key, value) {
    return {
        type: PackageTypes.SET_CONFIGURATIONS_TO_EDITABLE_PACKAGE,
        key,
        value,
    };
}
// E D I T   P A C K A G E


// T O G G L E   P A C K A G E   S T A T U S
export function togglePackageStatus(id, status) {
    return {
        type: PackageTypes.TOGGLE_PACKAGE_STATUS,
        id,
        status,
    };
}

export function togglePackageStatusRes() {
    return {
        type: actionCreator(PackageTypes.TOGGLE_PACKAGE_STATUS, 'res'),
    };
}

export function togglePackageStatusErr() {
    return {
        type: actionCreator(PackageTypes.TOGGLE_PACKAGE_STATUS, 'res'),
    };
}
// T O G G L E   P A C K A G E   S T A T U S
